import { IntlShape, defineMessages } from 'react-intl'
import * as yup from 'yup'

import { IBusinessSiteContactsValues } from 'features/BusinessSites/types'
import schemaValidations from 'utils/schema'

const messages = defineMessages({
  minContacts: {
    id: 'businessSites.new.contacts.min',
    defaultMessage: 'At least one contact is required'
  }
})

const nameMessages = defineMessages({
  required: {
    id: 'businessSites.new.contacts.name.required',
    defaultMessage: 'The contact name is required'
  },
  max: {
    id: 'businessSites.new.contacts.name.max',
    defaultMessage: 'The contact name must be at most {max} characters'
  }
})

const emailMessages = defineMessages({
  required: {
    id: 'businessSites.new.contacts.email.required',
    defaultMessage: 'The contact email is required'
  },
  max: {
    id: 'businessSites.new.contacts.email.max',
    defaultMessage: 'The contact email must be at most {max} characters'
  },
  format: {
    id: 'businessSites.new.contacts.email.format',
    defaultMessage: 'The contact email format is incorrect'
  }
})

export const schema = (intl: IntlShape): yup.SchemaOf<IBusinessSiteContactsValues> => {
  return yup.object().shape({
    contacts: yup
      .array()
      .of(
        yup.object().shape({
          id: yup.string(),
          name: yup
            .string()
            .max(50, ({ max }) => intl.formatMessage(nameMessages.max, { max }))
            .required(intl.formatMessage(nameMessages.required)),
          phone: schemaValidations(intl).phone.required,
          secondaryPhone: schemaValidations(intl).phone.optional,
          email: yup
            .string()
            .email(intl.formatMessage(emailMessages.format))
            .max(50, ({ max }) => intl.formatMessage(emailMessages.max, { max }))
            .required(intl.formatMessage(emailMessages.required)),
          secondaryEmail: yup.string().email()
        })
      )
      .min(1, intl.formatMessage(messages.minContacts))
  })
}
